module.exports = __webpack_public_path__ + "static/media/jessie-lose.4a6a482e.png";